// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const llama = defineModel({
  id: "llama",
  scale: 2.59, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Llama",
  tags: ["creature","llama","low-poly","age-of-mcp","future"],
  summary: "A llama — wool, a sure-footed pack animal, and meat.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.12,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.0085, 0.007, 0.09, 5), color: "#8c8270", position: [0.05, 0.045, 0.03] },
      { geometry: new THREE.CylinderGeometry(0.0085, 0.007, 0.09, 5), color: "#8c8270", position: [0.05, 0.045, -0.03] },
      { geometry: new THREE.CylinderGeometry(0.0085, 0.007, 0.09, 5), color: "#8c8270", position: [-0.05, 0.045, 0.03] },
      { geometry: new THREE.CylinderGeometry(0.0085, 0.007, 0.09, 5), color: "#8c8270", position: [-0.05, 0.045, -0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#d8cdb6", position: [0, 0.115, 0], scale: [1.5, 1, 0.9] },
      { geometry: new THREE.CylinderGeometry(0.016, 0.024, 0.085, 6), color: "#e4dbc7", position: [0.06, 0.18, 0], rotation: [0, 0, -0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#e4dbc7", position: [0.072, 0.225, 0], scale: [1.1, 1, 0.9] },
      { geometry: new THREE.BoxGeometry(0.02, 0.014, 0.018), color: "#e4dbc7", position: [0.09, 0.218, 0] },
      { geometry: new THREE.ConeGeometry(0.007, 0.022, 4), color: "#d8cdb6", position: [0.064, 0.247, 0.011], rotation: [0.2, 0, 0.1] },
      { geometry: new THREE.ConeGeometry(0.007, 0.022, 4), color: "#d8cdb6", position: [0.064, 0.247, -0.011], rotation: [-0.2, 0, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.084, 0.232, 0.013] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.084, 0.232, -0.013] },
      { geometry: new THREE.ConeGeometry(0.01, 0.022, 4), color: "#d8cdb6", position: [-0.072, 0.12, 0], rotation: [0, 0, 1.2] },
    ],
  animations: [],
});
